import React, { useRef, useState } from 'react';
import cn from 'classnames';
import { worksData, worksDataUA } from '../../data/worksData';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import styles from './Works.module.css';
import { useOutsideClick } from '../../hooks/hooks';
import WorkItem from './WorkItem';

export default function WorksList({ listNameActive, isMobile, language }) {
    const [isOpen, setIsOpen] = useState(false);
    const [hoveredLi, setHoveredLi] = useState(-1);

    const worksItemRef = useRef();

    const onTextToggler = (i, isOpen = null) => {
        if (hoveredLi === i) {
            openToggler();
            hideText();
        } else if (isOpen && hoveredLi > -1) {
            setHoveredLi(i);
            setIsOpen(true);
        } else {
            if (isOpen) {
                hideText();
            } else {
                setHoveredLi(i);
            }
            openToggler();
        }
    };
    const hideText = () => setHoveredLi(-1);
    const openToggler = () => setIsOpen((open) => !open);
    const showText = (i) => {
        setHoveredLi(i);
        setIsOpen(true);
    };

    useOutsideClick(worksItemRef, hideText);

    return (
        <ResponsiveMasonry columnsCountBreakPoints={{ 300: 1, 1150: 2 }}>
            <Masonry className={cn(styles.worksList)}>
                {(language === 'en' ? worksData : worksDataUA)
                    .filter((filterItem) => {
                        if (listNameActive === 'all') {
                            return filterItem;
                        }
                        return filterItem.type === listNameActive;
                    })
                    .sort((a, b) => b.sort - a.sort)
                    .map((item, i) => (
                        <WorkItem
                            item={item}
                            i={i}
                            isMobile={isMobile}
                            isOpen={isOpen}
                            showText={showText}
                            onTextToggler={onTextToggler}
                            hideText={hideText}
                            hoveredLi={hoveredLi}
                        />
                    ))}
            </Masonry>
        </ResponsiveMasonry>
    );
}
